import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { SpecialProgrammesFilterValue } from "@studyportals/search-api-interface";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { PortalType } from "@studyportals/domain-client";

export class SpecialProgrammesFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.SPECIAL_PROGRAMMES;
	public isMultiSelect = true;
	private static instance: SpecialProgrammesFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: SpecialProgrammesFilterValue.EXECUTIVE_PROGRAMMES, virtualPath: 'executive-programmes', name: 'Executive Programmes', portalTypes: [PortalType.MASTER, PortalType.PHD, PortalType.DISTANCE_LEARNING, PortalType.SHORT] },
		{ id: SpecialProgrammesFilterValue.JOINT_PROGRAMMES, virtualPath: 'joint-programmes', name: 'Joint Programmes' },
		{ id: SpecialProgrammesFilterValue.ERASMUS_MUNDUS, virtualPath: 'erasmus-mundus', name: 'Erasmus Mundus Joint Masters', portalTypes: [PortalType.MASTER, PortalType.PHD, PortalType.DISTANCE_LEARNING, PortalType.SHORT] },
	];

	public static getInstance(): SpecialProgrammesFilterMapper {
		if (!SpecialProgrammesFilterMapper.instance) {
			SpecialProgrammesFilterMapper.instance = new SpecialProgrammesFilterMapper();
		}
		return SpecialProgrammesFilterMapper.instance;
	}

	private constructor() {
		super();
	}
}
